import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/tokens.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { PermissionProvider } from './context/PermissionContext';
import { BranchProvider } from './context/BranchContext';
import { DashboardPreviewProvider } from './context/DashboardPreviewContext';

/**
 * Provider order matters: AuthProvider first (session), then
 * PermissionProvider (depends on session to call fn_get_my_context), then
 * BranchProvider (depends on the resolved context's roles to pick a default
 * branch). This is the real app entrypoint — no demo/mock provider or
 * fallback state exists anywhere in this tree.
 *
 * STATUS: IMPLEMENTED_UNVERIFIED — see docs/data-dictionary.md §8k.
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <PermissionProvider>
          <BranchProvider>
            <DashboardPreviewProvider>
              <App />
            </DashboardPreviewProvider>
          </BranchProvider>
        </PermissionProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
